import theme from '../theme-config';
import './avenir.css';
import fontTrackingCode from './mtiFontTrackingCode.js?raw';

const MONOTYPE_PROJECT_ID = '38da1505-c7a1-43ee-8c8f-f05c6d45c1f5';
const AVENIR_FONT_IDS = ['5686127', '5687178', '5687390', '6288185'];

// ECharts draws text on canvas and never redraws once a late face arrives
const loadAllFaces = () =>
    Object.values(theme.typography.fontWeight).forEach((weight) =>
        document.fonts.load(`${weight} 1em Avenir`).catch(() => undefined)
    );

// html-to-image logs an error on every export for a cross-origin stylesheet it can't read
const removeTrackingStylesheetOnceLoaded = () => {
    const stylesheet = document.querySelector('link[href*="fast.fonts.net/lt/1.css"]');
    stylesheet?.addEventListener('load', () => stylesheet.remove());
};

export const initializeFonts = () => {
    loadAllFaces();
    Object.assign(window, { MTUserId: MONOTYPE_PROJECT_ID, MTFontIds: AVENIR_FONT_IDS });

    const trackingScript = document.createElement('script');
    trackingScript.textContent = fontTrackingCode;
    document.head.appendChild(trackingScript);
    removeTrackingStylesheetOnceLoaded();
};
